import type { UserLoginResponse } from '../types/cafe';

// 토큰은 sessionStorage(미니앱 종료 시 삭제)에 두고, "로그인한 적 있음" 표시만 localStorage 에 남긴다.
// 다시 열 때 이 표시가 있으면 appLogin 을 자동 호출한다 — 이미 동의한 사용자는 토스 창 없이 바로 인가코드가 온다.
const LOGIN_MARK_KEY = 'has_logged_in';

/** 로그인한 계정의 권한으로 교체하며 이전 계정의 사장님 인증을 남기지 않는다. */
export function saveLoginSession(result: UserLoginResponse) {
  sessionStorage.setItem('user_token', result.token);
  sessionStorage.setItem('user_id', String(result.userId));
  sessionStorage.setItem('user_name', result.name || '');
  if (result.owner) {
    sessionStorage.setItem('owner_token', result.owner.ownerToken);
    sessionStorage.setItem('owner_cafe_id', String(result.owner.cafeId));
    sessionStorage.setItem('owner_cafe_name', result.owner.cafeName);
  } else {
    sessionStorage.removeItem('owner_token');
    sessionStorage.removeItem('owner_cafe_id');
    sessionStorage.removeItem('owner_cafe_name');
  }
  try {
    localStorage.setItem(LOGIN_MARK_KEY, '1');
  } catch {
    // 저장소 차단 — 다음 실행 때 버튼 로그인으로 돌아갈 뿐이다.
  }
}

export function hasLoginMark(): boolean {
  try {
    return localStorage.getItem(LOGIN_MARK_KEY) === '1';
  } catch {
    return false;
  }
}

/** 자동 로그인에 실패하면(토스 '연결 끊기' 등) 표시를 지워 다음부터 버튼 로그인으로 돌아간다. */
export function clearLoginMark() {
  try {
    localStorage.removeItem(LOGIN_MARK_KEY);
  } catch {
    // ignore
  }
}
